import { MapPin, Navigation } from "lucide-react";

// Via Cagliero, Milano (Zona Maggiolina) — sede
const LAT = 45.4968621;
const LON = 9.2002376;
const BBOX = "9.1902,45.4919,9.2103,45.5019";
const OSM_EMBED = `https://www.openstreetmap.org/export/embed.html?bbox=${BBOX}&layer=mapnik&marker=${LAT},${LON}`;
const OSM_LINK = `https://www.openstreetmap.org/?mlat=${LAT}&mlon=${LON}#map=16/${LAT}/${LON}`;

export default function MapSection() {
  return (
    <section
      id="zona"
      data-testid="map-section"
      className="py-24 md:py-32 bg-[#EFECE5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <p className="overline mb-6">— Dove lavoro</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A3628]">
            Nel cuore di <br />
            <span className="font-accent italic font-normal">Milano</span>.
          </h2>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#5C6B62] max-w-md">
            Ho sede in <strong className="text-[#1A3628] font-medium">Via Cagliero</strong>,
            nella <strong className="text-[#1A3628] font-medium">Zona Maggiolina</strong> —
            uno dei quartieri più verdi di Milano, tra ville, giardini storici e
            case immerse nel verde. Da qui raggiungo tutta la città e la provincia
            per prendermi cura dei tuoi spazi.
          </p>

          <div className="mt-8 flex flex-col gap-4">
            <div className="flex items-start gap-4">
              <span className="inline-flex items-center justify-center w-11 h-11 border border-[#1A3628]/25 shrink-0">
                <MapPin size={18} strokeWidth={1.5} className="text-[#1A3628]" />
              </span>
              <div>
                <p className="overline">Quartiere</p>
                <p className="text-base text-[#1A3628] mt-1">Via Cagliero · Maggiolina, Milano</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="inline-flex items-center justify-center w-11 h-11 border border-[#1A3628]/25 shrink-0">
                <Navigation size={18} strokeWidth={1.5} className="text-[#1A3628]" />
              </span>
              <div>
                <p className="overline">Area servita</p>
                <p className="text-base text-[#1A3628] mt-1">Milano città e provincia</p>
              </div>
            </div>
          </div>

          <a
            href={OSM_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="map-open-link"
            className="btn-ghost text-[#1A3628] mt-8"
          >
            Apri la mappa →
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="relative border border-[#1A3628]/15 bg-[#FAF9F6] p-2 shadow-[0_30px_60px_-30px_rgba(26,54,40,0.35)]">
            {/* Etichetta zona in risalto */}
            <div className="absolute z-10 top-5 left-5 bg-[#1A3628] text-[#FAF9F6] px-5 py-3 shadow-lg">
              <p className="overline !text-[#FAF9F6]/60">Zona</p>
              <p className="font-serif-display text-xl md:text-2xl tracking-tight leading-none mt-1">
                Maggiolina
              </p>
            </div>
            <iframe
              title="Mappa Zona Maggiolina, Milano"
              data-testid="map-iframe"
              src={OSM_EMBED}
              className="w-full h-[360px] md:h-[460px] grayscale-[0.15] contrast-[1.05]"
              loading="lazy"
              style={{ border: 0 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
